<template>
    <div class="add-event-type">
        <div class="centered vue-loader" style="height: 350px" v-if="loading">
            <vue-loader></vue-loader>
        </div>
        <div v-else>
            <div style="display: flex; justify-content: flex-end;padding: 10px 20px">
                <!--                <div class="event-card">-->
                <div class="clip-path-content" style="position: absolute;">
                    <div class="inner">
                        <span>info</span>
                      <div v-if="active_tab === '0'">
                          <h1>Bus Line</h1>
                          <p>Add line name like Tetovo - Gostivar,<br /> Time like: 1h: 30min, <br />price like: 100,<br /> distance like 93.2</p>
                      </div>
                        <div v-else-if="active_tab === '1'">
                            <h1>Line Calendar</h1>
                            <p>Add line name like Tetovo - Gostivar,<br /> Station name like: Tetovo,<br /> Time like 08:30</p>
                        </div>
                        <div v-else>
                            <h1>Station</h1>
                            <p>Company name like AVIX,<br /> latitude like:14.13312,<br /> longitude like 32.2211332</p>
                        </div>
                    </div>
                </div>
                <!--                </div>-->
            </div>
            <el-tabs
                    style="display: flex; justify-content: space-between; flex-direction: column;align-items: center;width: 100%"
                    v-model="active_tab">
                <el-tab-pane class="el-tabs__content">
                    <label style="width: 100%" slot="label">Add Bus Line<span class="danger"></span></label>
                    <add-bus-line></add-bus-line>
                </el-tab-pane>
                <el-tab-pane class="el-tabs__content" >
                    <label slot="label">Add Bus Line Calendar</label>
                    <el-form ref="addBusCompany" :model="bus_line_calendar" :rules="formRules"
                             label-position="left"
                             class="newEventFormStyle">
                        <el-form-item label="Line name" prop="lineName">
                            <el-input v-model="bus_line_calendar.lineName"></el-input>
                        </el-form-item>
                        <el-form-item label="Station name" prop="station_name">
                            <el-input v-model="bus_line_calendar.stationName"></el-input>
                        </el-form-item>
                        <el-form-item label="Time" prop="time">
                            <el-time-select
                                    style="width: 100%"
                                    v-model="bus_line_calendar.time"
                                    :picker-options="{
                            start: '00:00',
                            step: '00:05',
                            end: '23:59'
                          }"
                                    placeholder="Select time">
                            </el-time-select>
                        </el-form-item>
                        <el-button type="primary" style="width: 100%" :loading="loading" @click="addBusLineCalendar">
                            Add
                        </el-button>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane class="el-tabs__content">
                    <label slot="label">Add Station</label>
                    <el-form ref="addBusCompany" :model="bus_station"
                             label-position="left"
                             class="newEventFormStyle">
                        <el-form-item label="Company name" prop="name">
                            <el-input v-model="bus_station.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Latitude" prop="latitude">
                            <el-input type="phone-number" v-model="bus_station.latitude"></el-input>
                        </el-form-item>
                        <el-form-item label="Longitude" prop="longitude">
                            <el-input v-model="bus_station.longitude"></el-input>
                        </el-form-item>
                        <el-button type="primary" style="width: 100%" :loading="loading" @click="addBusStation">Add
                            Station
                        </el-button>

                    </el-form>
                </el-tab-pane>
            </el-tabs>

        </div>


    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import {LoaderIcon} from 'vue-feather-icons'
    import BusService from '@/common/services/bus.service'
    import {uploadImageToImgur} from "../../common/services/image.upload.service";
    import AddBusLine from "./AddBusLine";

    export default {
        name: "AddBusStation",
        components: {AddBusLine, VueLoader: LoaderIcon},
        data() {
            return {
                loading: false,
                bus_company: {
                    name: null,
                    phoneNumber: null,
                    userEmail: null,
                    photo: null,
                },
                active_tab: 0,
                bus_station: {
                    name: '',
                    latitude: '',
                    longitude: '',
                },
                bus_line_calendar: {
                    userEmail: '',
                    lineName: '',
                    stationName: '',
                    time: ''
                },
                formRules: {
                    lineName: {
                        required: true,
                        trigger: 'change',
                    },
                    phoneNumber: {
                        required: true,
                        trigger: 'change',
                    },
                    userEmail: {
                        required: true,
                        trigger: 'change',
                    },
                },
            }
        },
        computed: {
            ...mapState({
                user_email: state => state.user.user_email,
            })
        },
        methods: {
            addBusLineCalendar() {
                this.loading = true;
                this.bus_line_calendar.userEmail = this.user_email;
                BusService.addBusLineCalendar(this.bus_line_calendar).then(() => {
                    this.$notify.success({
                        title: `Bus`,
                        message: 'Successfully added bus line calendar'
                    });
                    this.$emit('close')
                }).catch(error => {
                    this.$notify.error({
                        title: `Failed to add bus line calendar`,
                        message: error.response.data.message
                    });
                }).finally(() => this.loading = false)
            },
            addBusStation() {
                this.loading = true;
                this.bus_line_calendar.userEmail = this.user_email;
                BusService.AddBusStation(this.bus_line_calendar).then(() => {
                    this.$notify.success({
                        title: `Bus`,
                        message: 'Successfully added bus line calendar'
                    });
                    this.$emit('close')
                }).catch(error => {
                    this.$notify.error({
                        title: `Failed to add bus line calendar`,
                        message: error.response.data.message
                    });
                }).finally(() => this.loading = false)
            },
            onEditPhoto() {
                let input = document.createElement('input');
                input.type = 'file';
                input.click();
                input.onchange = e => {
                    let file = e.target.files[0];
                    this.onFileSelected(file);
                }
            },
            onFileSelected(image) {
                this.loading = true;
                let formData = new FormData();
                formData.append('image', image);
                uploadImageToImgur(image).then(res => {
                    this.bus_company.photo = res
                }).catch(er => {
                    console.log(er);
                    this.$notify.error({
                        title: `Failed to upload image`,
                        message: er.response.data.data.error
                    });
                }).finally(() => {
                    this.loading = false;
                });
            },
            save() {
                this.$refs['addBusCompany'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        BusService.addBusCompany(this.bus_company).then(() => {
                            this.$notify.success({
                                title: `Bus`,
                                message: 'Successfully added bus company'
                            });
                            this.$emit('close')
                        }).catch(error => {
                            this.$notify.error({
                                title: `Failed to add bus company`,
                                message: error.response.data.message
                            });
                        }).finally(() => this.loading = false)
                    } else {
                        return false;
                    }
                })
            },
        },
        beforeMount() {
            console.log(this.active_tab)
        }
    }
</script>
<style scoped lang="scss">
    .add-event-type {
        h3 {
            margin: 0;
        }

        .add-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            .add-button {
                background-color: #efefef;
                border: 1px solid lightgray;
                width: 100%;
                padding: 10px 0;
                cursor: pointer;
            }
        }

        .form {
            .no-image-container {
                background-color: #f8f8f8;
                display: flex;
                width: 100%;
                height: 150px;
                cursor: pointer;

                .no-image-contents {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    flex-direction: column;
                    border-radius: 4px;
                }
            }

            .image-container {
                display: flex;
                justify-content: center;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                cursor: pointer;
            }

            .file-select {

            }

            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }

        }

        .footer-btn {
            display: flex;
            justify-content: flex-end;
        }

        .event-card {
            position: absolute;
            border: 1px solid whitesmoke;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            border-radius: 5px;
            cursor: pointer;
            -webkit-box-shadow: 0 0 5px #c7c1c1;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-family: 'Lato', sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

    }

    .el-tabs__content {
        min-width: 384px;
    }
</style>
